import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('ds_token'));
  const [loading, setLoading] = useState(true);

  // Inject token into every axios request
  useEffect(() => {
    const id = api.interceptors.request.use(config => {
      const t = localStorage.getItem('ds_token');
      if (t) config.headers.Authorization = `Bearer ${t}`;
      return config;
    });
    return () => api.interceptors.request.eject(id);
  }, []);

  // On mount: verify stored token with /auth/me
  const fetchMe = useCallback(async (tkn) => {
    if (!tkn) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me', {
        headers: { Authorization: `Bearer ${tkn}` },
      });
      setUser(data);
    } catch {
      // Token invalid/expired — clear
      localStorage.removeItem('ds_token');
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(token); }, [token, fetchMe]);

  const login = (tokenStr, userData) => {
    localStorage.setItem('ds_token', tokenStr);
    setToken(tokenStr);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('ds_token');
    localStorage.removeItem('ds_active_connection');
    localStorage.removeItem('ds_active_chat');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAuth: !!user && !!token, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
